export default "<ngx-loading-bar color=\"#14317a \" height=\"4px\"></ngx-loading-bar>\n<router-outlet></router-outlet>\n";